{
  "password_length": "密码长度必须在8-50位之间",
  "password_strength": "密码必须包含大小写字母和数字"
}
